<fieldset class="pr-3" [formGroup]="addressForm">
  <mat-form-field class="w-full">
    <mat-label>Address</mat-label>
    <input
      matInput
      google-place
      [placeholder]="'Start typing...'"
      [formControlName]="'address_string'"
      (onSelect)="setAddress($event)"
      (onSelectParts)="onSelectAddressParts($event)"
      autocomplete="none"
      [readonly]="readonly"
    />
  </mat-form-field>
</fieldset>
